export { default } from './SolutionTemplate';
